import React from 'react';
import PropTypes from 'prop-types';
import Article from '~/containers/ArticleContainer/ArticleContainer';
import Ad, { AdTypes } from '~/containers/AdContainer/AdContainer';
import StyledComponent from '~/components/Styled/Styled';

import css from '~/components/ArticleList/ArticleList.scss';
import masonry from '~/static/css/masonry.css';

/* eslint-disable react/prefer-stateless-function */

const renderArticle = article => (
  <div className={masonry.gridItem} key={article.id}>
    <Article article={article} currentCard={false} />
  </div>
);

class ArticleList extends React.PureComponent {
  render() {
    const { articles } = this.props;
    const firstTwoArticles = articles.slice(0, 2);
    const remainingArticles = articles.slice(2);

    return (
      <div>
        {firstTwoArticles.map(article => renderArticle(article))}

        <div className={masonry.gridItem}>
          <Ad adType={AdTypes.BIGBOX_MOBILE} />
          <Ad adType={AdTypes.BIGBOX_DESKTOP} />
        </div>

        {remainingArticles.map(article => renderArticle(article))}
      </div>
    );
  }
}

ArticleList.propTypes = {
  articles: PropTypes.array,
};

ArticleList.defaultProps = {
  articles: [],
};

ArticleList.displayName = 'ArticleList';

export default StyledComponent(ArticleList, [css, masonry]);
